import React, { useState, useEffect } from 'react';
import './App.css';

import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';

import { Register } from './Register';




const impressum = `


<font face="Times New Roman, serif"><font size="6" style="font-size: 24pt"><b>Impressum</b></font></font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif"><font size="4" style="font-size: 13pt"><b>Inhaltlich
verantwortlich gem. §5 TMG</b></font></font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif"><font size="4" style="font-size: 13pt"><b>Herausgeber</b></font></font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif"><b>Adresse:</b></font><font face="Times New Roman, serif"><br/>
Kneipenchor
Linden e.V., gegründet 2025<br/>
Lichtenbergplatz 7 <br/>
30449
Hannover</font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif"><b>Kontakt:</b></font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif">kneipenchorlinden@gmail.com</font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif"><font size="4" style="font-size: 13pt"><b>Vertretungsberechtigt
und Rechtliches </b></font></font>
</p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif"><b>Vorstand:<br/>
</b></font><font face="Times New Roman, serif">Amelie
Hetzer, Henri Hesse, Niklas Schneeweiß</font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif"><b>Rechtsform:</b></font><font face="Times New Roman, serif"><br/>
Verein<br/>
</font><br/>
<br/>

</p>
<p style="line-height: 100%; margin-top: 0.19in; margin-bottom: 0.19in">
<br/>
<br/>

</p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif"><font size="4" style="font-size: 13pt"><b>Bildnachweise</b></font></font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif"><b>Eigenes Material:</b></font><font face="Times New Roman, serif"><br/>
Diverse
eigene Archive<br/>
<br/>
</font><br/>
<br/>

</p>
<p style="line-height: 100%; margin-bottom: 0in"><br/>

</p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%; page-break-before: always">
<font face="Times New Roman, serif"><font size="5" style="font-size: 18pt"><b>Hinweis
nach VSBG </b></font></font>
</p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif"><b>Online-Streitbeilegung gemäß
Art. 14 Abs. 1 ODR-VO<br/>
</b></font><font face="Times New Roman, serif">Die
Europäische Kommission stellt eine Plattform zur
Online-Streitbeilegung (OS) bereit, die Sie
unter&nbsp;</font><a href="http://ec.europa.eu/consumers/odr/" target="_blank"><font color="#0000ff"><font face="Times New Roman, serif"><u>http://ec.europa.eu/consumers/odr/</u></font></font></a><font face="Times New Roman, serif">&nbsp;finden.</font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif"><b>Hinweis nach
Verbraucherstreitbeilegungsgesetz</b></font><font face="Times New Roman, serif"><br/>
Wir
sind grundsätzlich nicht bereit und verpflichtet, an
Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle
teilzunehmen.</font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif"><font size="5" style="font-size: 18pt"><b>Haftungshinweis</b></font></font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif">Für alle Links gilt, dass wir
keinerlei Einfluss auf die Gestaltung und die Inhalte der gelinkten
Seite haben. Deshalb distanzieren wir uns hiermit ausdrücklich von
allen Inhalten aller gelinkten Seiten auf unserer gesamten Website
inkl. aller Unterseiten. Diese Erklärung gilt für alle auf dieser
Homepage angebrachten Links und für alle Inhalte der Seiten, zu
denen Links oder Banner führen.</font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif">Alle Rechte vorbehalten. Die
dargestellten Informationen sind Eigentum des Kneipenchor Linden
e.V.. Sie stellen die zum Zeitpunkt der Publikation jeweils neuesten
Informationen dar. Eine Haftung oder Garantie für die Aktualität,
Richtigkeit und Vollständigkeit der zur Verfügung gestellten
Informationen und Daten ist ausgeschlossen. Dieses gilt ebenso für
alle anderen Webseiten, auf die mittels eines sogenannten Hyperlinks
verwiesen wird. Für den Inhalt solcher Webseiten ist der Kneipenchor
Linden e.V. nicht verantwortlich.</font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif">Die Informationen auf den
Webseiten stellen in keinem Fall rechtliche Zusicherungen dar. Der
Kneipenchor Linden e.V. behält sich das Recht vor, bei Bedarf
Änderungen oder Ergänzungen der bereitgestellten Informationen oder
Daten durchzuführen. Aus den hier beschriebenen Themenbereichen
können keine Rechtsansprüche abgeleitet werden. Angebote sind in
allen Teilen ausschließlich unverbindlich.</font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif">Der Kneipenchor Linden e.V.
haftet weder für direkte noch indirekte Schäden, die durch die
Nutzung der Informationen oder Daten entstehen, die auf dieser
Webseite zu finden sind. Rechte und Pflichten zwischen dem
Kneipenchor Linden e.V. und dem einzelnen Nutzer der Webseite oder
Dritten bestehen nicht.</font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif">Die Inhalte der Webseite des
Kneipenchor Linden e.V. sind urheberrechtlich geschützt. Die Inhalte
dürfen weder ganz noch teilweise ohne vorherige schriftliche
Genehmigung des Urhebers vervielfältigt und resp. oder
veröffentlicht oder in einem Informationssystem gespeichert werden.</font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif">Sämtliche Informationen oder
Daten, ihre Nutzung sowie sämtliches mit der Webseite des
Kneipenchor Linden e.V. zusammenhängendes Tun, Dulden oder
Unterlassen unterliegen ausschließlich deutschem Recht, unter
Ausschluss von internationalem Recht. Erfüllungsort und
ausschließlicher Gerichtsstand ist Hannover.</font></p>
<p style="margin-bottom: 0in; line-height: 100%"><br/>
</p>
`;

const datenschutz = `


<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif"><font size="6" style="font-size: 24pt"><b>Datenschutz</b></font></font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif"><font size="4" style="font-size: 13pt"><b>Deine
Daten sind uns wichtig</b></font></font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif"><font size="4" style="font-size: 13pt"><b>1.
Datenschutz auf einen Blick ​</b></font></font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif"><font size="4" style="font-size: 13pt"><b>Allgemeine
Hinweise</b></font></font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif">Die folgenden Hinweise geben
einen einfachen Überblick darüber, was mit Ihren personenbezogenen
Daten passiert, wenn Sie unsere Website besuchen. Personenbezogene
Daten sind alle Daten, mit denen Sie persönlich identifiziert werden
können. Ausführliche Informationen zum Thema Datenschutz entnehmen
Sie unserer unter diesem Text aufgeführten Datenschutzerklärung.</font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif"><font size="4" style="font-size: 13pt"><b>Datenerfassung
auf unserer Website</b></font></font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif"><b>Wer ist verantwortlich für
die Datenerfassung auf dieser Website?</b></font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif">Die Datenverarbeitung auf dieser
Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten
können Sie dem Impressum dieser Website entnehmen.</font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif"><b>Wie erfassen wir Ihre Daten?</b></font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif">Ihre Daten werden zum einen
dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann es sich
z.B. um Daten handeln, die Sie in ein Kontaktformular eingeben.</font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif">Andere Daten werden automatisch
beim Besuch der Website durch unsere IT-Systeme erfasst. Das sind vor
allem technische Daten (z.B. Internetbrowser, Betriebssystem oder
Uhrzeit des Seitenaufrufs). Die Erfassung dieser Daten erfolgt
automatisch, sobald Sie unsere Website betreten.</font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif"><b>Wofür nutzen wir Ihre Daten?</b></font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif">Ein Teil der Daten wird erhoben,
um eine fehlerfreie Bereitstellung der Website zu gewährleisten.
Andere Daten können zur Analyse Ihres Nutzerverhaltens verwendet
werden.</font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif"><b>Welche Rechte haben Sie
bezüglich Ihrer Daten?</b></font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif">Sie haben jederzeit das Recht
unentgeltlich Auskunft über Herkunft, Empfänger und Zweck Ihrer
gespeicherten personenbezogenen Daten zu erhalten. Sie haben außerdem
ein Recht, die Berichtigung, Sperrung oder Löschung dieser Daten zu
verlangen. Hierzu sowie zu weiteren Fragen zum Thema Datenschutz
können Sie sich jederzeit unter der im Impressum angegebenen Adresse
an uns wenden. Des Weiteren steht Ihnen ein Beschwerderecht bei der
zuständigen Aufsichtsbehörde zu.</font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif"><font size="4" style="font-size: 13pt"><b>Analyse-Tools
und Tools von Drittanbietern</b></font></font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif">Beim Besuch unserer Website kann
Ihr Surf-Verhalten statistisch ausgewertet werden. Das geschieht vor
allem mit Cookies und mit sogenannten Analyseprogrammen. Die Analyse
Ihres Surf-Verhaltens erfolgt in der Regel anonym; das Surf-Verhalten
kann nicht zu Ihnen zurückverfolgt werden. Sie können dieser
Analyse widersprechen oder sie durch die Nichtbenutzung bestimmter
Tools verhindern. Detaillierte Informationen dazu finden Sie in der
folgenden Datenschutzerklärung.</font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif">Sie können dieser Analyse
widersprechen. Über die Widerspruchsmöglichkeiten werden wir Sie in
dieser Datenschutzerklärung informieren.</font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif"><font size="4" style="font-size: 13pt"><b>2.
Allgemeine Hinweise und Pflichtinformationen</b></font></font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif"><font size="4" style="font-size: 13pt"><b>Datenschutz</b></font></font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif">Die Betreiber dieser Seiten
nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir behandeln
Ihre personenbezogenen Daten vertraulich und entsprechend der
gesetzlichen Datenschutzvorschriften sowie dieser
Datenschutzerklärung.</font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif">Wenn Sie diese Website benutzen,
werden verschiedene personenbezogene Daten erhoben. Personenbezogene
Daten sind Daten, mit denen Sie persönlich identifiziert werden
können. Die vorliegende Datenschutzerklärung erläutert, welche
Daten wir erheben und wofür wir sie nutzen. Sie erläutert auch, wie
und zu welchem Zweck das geschieht.</font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif">Wir weisen darauf hin, dass die
Datenübertragung im Internet (z.B. bei der Kommunikation per E-Mail)
Sicherheitslücken aufweisen kann. Ein lückenloser Schutz der Daten
vor dem Zugriff durch Dritte ist nicht möglich.</font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
&nbsp;</p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
&nbsp;</p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif"><font size="4" style="font-size: 13pt"><b>Hinweis
zur verantwortlichen Stelle</b></font></font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif">Die verantwortliche Stelle für
die Datenverarbeitung auf dieser Website ist:</font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif">Kneipenchor Linden e.V.,
gegründet 2025<br/>
Lichtenbergplatz 7 <br/>
30449 Hannover</font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif">info@kneipenchor<!-- bei der Domain registrieren und weiterleitung machen?
 -->-linden.de</font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif">Verantwortliche Stelle ist die
natürliche oder juristische Person, die allein oder gemeinsam mit
anderen über die Zwecke und Mittel der Verarbeitung von
personenbezogenen Daten (z.B. Namen, E-Mail-Adressen o. Ä.)
entscheidet.</font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
&nbsp;</p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
&nbsp;</p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif"><font size="4" style="font-size: 13pt"><b>Widerruf
Ihrer Einwilligung zur Datenverarbeitung</b></font></font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif">Viele Datenverarbeitungsvorgänge
sind nur mit Ihrer ausdrücklichen Einwilligung möglich. Sie können
eine bereits erteilte Einwilligung jederzeit widerrufen. Dazu reicht
eine formlose Mitteilung per E-Mail an uns. Die Rechtmäßigkeit der
bis zum Widerruf erfolgten Datenverarbeitung bleibt vom Widerruf
unberührt.</font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
&nbsp;</p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
&nbsp;</p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif"><font size="4" style="font-size: 13pt"><b>Beschwerderecht
bei der zuständigen Aufsichtsbehörde</b></font></font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif">Im Falle datenschutzrechtlicher
Verstöße steht dem Betroffenen ein Beschwerderecht bei der
zuständigen Aufsichtsbehörde zu. Zuständige Aufsichtsbehörde in
datenschutzrechtlichen Fragen ist der Landesdatenschutzbeauftragte
des Bundeslandes, in dem unser Unternehmen seinen Sitz hat. Eine
Liste der Datenschutzbeauftragten sowie deren Kontaktdaten können
folgendem Link entnommen
werden:&nbsp;</font><a href="https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html" target="_blank"><font color="#0000ff"><font face="Times New Roman, serif"><u>https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html</u></font></font></a><font face="Times New Roman, serif">.</font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
&nbsp;</p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
&nbsp;</p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif"><font size="4" style="font-size: 13pt"><b>Recht
auf Datenübertragbarkeit</b></font></font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif">Sie haben das Recht, Daten, die
wir auf Grundlage Ihrer Einwilligung oder in Erfüllung eines
Vertrags automatisiert verarbeiten, an sich oder an einen Dritten in
einem gängigen, maschinenlesbaren Format aushändigen zu lassen.
Sofern Sie die direkte Übertragung der Daten an einen anderen
Verantwortlichen verlangen, erfolgt dies nur, soweit es technisch
machbar ist.</font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
&nbsp;</p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
&nbsp;</p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif"><font size="4" style="font-size: 13pt"><b>SSL-
bzw. TLS-Verschlüsselung</b></font></font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif">Diese Seite nutzt aus
Sicherheitsgründen und zum Schutz der Übertragung vertraulicher
Inhalte, wie zum Beispiel Bestellungen oder Anfragen, die Sie an uns
als Seitenbetreiber senden, eine SSL-bzw. TLS-Verschlüsselung. Eine
verschlüsselte Verbindung erkennen Sie daran, dass die Adresszeile
des Browsers von “http://” auf “https://” wechselt und an dem
Schloss-Symbol in Ihrer Browserzeile.</font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif">Wenn die SSL- bzw.
TLS-Verschlüsselung aktiviert ist, können die Daten, die Sie an uns
übermitteln, nicht von Dritten mitgelesen werden.</font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
&nbsp;</p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif"><font size="4" style="font-size: 13pt"><b>Verschlüsselter
Zahlungsverkehr auf dieser Website</b></font></font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif">Besteht nach dem Abschluss eines
kostenpflichtigen Vertrags eine Verpflichtung, uns Ihre Zahlungsdaten
(z.B. Kontonummer bei Einzugsermächtigung) zu übermitteln, werden
diese Daten zur Zahlungsabwicklung benötigt.</font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif">Der Zahlungsverkehr über die
gängigen Zahlungsmittel (Lastschriftverfahren) erfolgt
ausschließlich über eine verschlüsselte SSL- bzw. TLS-Verbindung.
Eine verschlüsselte Verbindung erkennen Sie daran, dass die
Adresszeile des Browsers von “http://” auf “https://”
wechselt und an dem Schloss-Symbol in Ihrer Browserzeile.</font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif">Bei verschlüsselter
Kommunikation können Ihre Zahlungsdaten, die Sie an uns übermitteln,
nicht von Dritten mitgelesen werden.</font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
&nbsp;</p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
&nbsp;</p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif"><font size="4" style="font-size: 13pt"><b>Auskunft,
Sperrung, Löschung</b></font></font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif">Sie haben im Rahmen der geltenden
gesetzlichen Bestimmungen jederzeit das Recht auf unentgeltliche
Auskunft über Ihre gespeicherten personenbezogenen Daten, deren
Herkunft und Empfänger und den Zweck der Datenverarbeitung und ggf.
ein Recht auf Berichtigung, Sperrung oder Löschung dieser Daten.
Hierzu sowie zu weiteren Fragen zum Thema personenbezogene Daten
können Sie sich jederzeit unter der im Impressum angegebenen Adresse
an uns wenden.</font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
&nbsp;</p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
&nbsp;</p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif"><font size="4" style="font-size: 13pt"><b>Widerspruch
gegen Werbe-Mails</b></font></font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif">Der Nutzung von im Rahmen der
Impressumspflicht veröffentlichten Kontaktdaten zur Übersendung von
nicht ausdrücklich angeforderter Werbung und Informationsmaterialien
wird hiermit widersprochen. Die Betreiber der Seiten behalten sich
ausdrücklich rechtliche Schritte im Falle der unverlangten Zusendung
von Werbeinformationen, etwa durch Spam-E-Mails, vor.</font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif"><font size="4" style="font-size: 13pt"><b>3.
Datenerfassung auf unserer Website</b></font></font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif"><font size="4" style="font-size: 13pt"><b>Cookies</b></font></font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif">Die Internetseiten verwenden
teilweise so genannte Cookies. Cookies richten auf Ihrem Rechner
keinen Schaden an und enthalten keine Viren. Cookies dienen dazu,
unser Angebot nutzerfreundlicher, effektiver und sicherer zu machen.
Cookies sind kleine Textdateien, die auf Ihrem Rechner abgelegt
werden und die Ihr Browser speichert.</font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif">Die meisten der von uns
verwendeten Cookies sind so genannte “Session-Cookies”. Sie
werden nach Ende Ihres Besuchs automatisch gelöscht. Andere Cookies
bleiben auf Ihrem Endgerät gespeichert bis Sie diese löschen. Diese
Cookies ermöglichen es uns, Ihren Browser beim nächsten Besuch
wiederzuerkennen.</font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif">Sie können Ihren Browser so
einstellen, dass Sie über das Setzen von Cookies informiert werden
und Cookies nur im Einzelfall erlauben, die Annahme von Cookies für
bestimmte Fälle oder generell ausschließen sowie das automatische
Löschen der Cookies beim Schließen des Browser aktivieren. Bei der
Deaktivierung von Cookies kann die Funktionalität dieser Website
eingeschränkt sein.</font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif">Cookies, die zur Durchführung
des elektronischen Kommunikationsvorgangs oder zur Bereitstellung
bestimmter, von Ihnen erwünschter Funktionen (z.B.
Warenkorbfunktion) erforderlich sind, werden auf Grundlage von Art. 6
Abs. 1 lit. f DSGVO gespeichert. Der Websitebetreiber hat ein
berechtigtes Interesse an der Speicherung von Cookies zur technisch
fehlerfreien und optimierten Bereitstellung seiner Dienste. Soweit
andere Cookies (z.B. Cookies zur Analyse Ihres Surfverhaltens)
gespeichert werden, werden diese in dieser Datenschutzerklärung
gesondert behandelt.</font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif"><font size="4" style="font-size: 13pt"><b>Server-Log-Dateien</b></font></font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif">Der Provider der Seiten erhebt
und speichert automatisch Informationen in so genannten
Server-Log-Dateien, die Ihr Browser automatisch an uns übermittelt.
Dies sind:</font></p>
<ul>
	<li><p style="margin-top: 0.19in; margin-bottom: 0in; line-height: 100%">
	<font face="Times New Roman, serif">Browsertyp und Browserversion</font></p></li>
	<li><p style="margin-bottom: 0in; line-height: 100%"><font face="Times New Roman, serif">verwendetes
	Betriebssystem</font></p></li>
	<li><p style="margin-bottom: 0in; line-height: 100%"><font face="Times New Roman, serif">Referrer
	URL</font></p></li>
	<li><p style="margin-bottom: 0in; line-height: 100%"><font face="Times New Roman, serif">Hostname
	des zugreifenden Rechners</font></p></li>
	<li><p style="margin-bottom: 0in; line-height: 100%"><font face="Times New Roman, serif">Uhrzeit
	der Serveranfrage</font></p></li>
	<li><p style="margin-bottom: 0.19in; line-height: 100%"><font face="Times New Roman, serif">IP-Adresse</font></p></li>
</ul>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif">Eine Zusammenführung dieser
Daten mit anderen Datenquellen wird nicht vorgenommen.</font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif">Grundlage für die
Datenverarbeitung ist Art. 6 Abs. 1 lit. b DSGVO, der die
Verarbeitung von Daten zur Erfüllung eines Vertrags oder
vorvertraglicher Maßnahmen gestattet.</font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif"><font size="4" style="font-size: 13pt"><b>Kontaktformular</b></font></font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif">Wenn Sie uns per Kontaktformular
Anfragen zukommen lassen, werden Ihre Angaben aus dem Anfrageformular
inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks
Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns
gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung
weiter.</font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif">Die Verarbeitung der in das
Kontaktformular eingegebenen Daten erfolgt somit ausschließlich auf
Grundlage Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO). Sie können
diese Einwilligung jederzeit widerrufen. Dazu reicht eine formlose
Mitteilung per E-Mail an uns. Die Rechtmäßigkeit der bis zum
Widerruf erfolgten Datenverarbeitungsvorgänge bleibt vom Widerruf
unberührt.</font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif">Die von Ihnen im Kontaktformular
eingegebenen Daten verbleiben bei uns, bis Sie uns zur Löschung
auffordern, Ihre Einwilligung zur Speicherung widerrufen oder der
Zweck für die Datenspeicherung entfällt (z.B. nach abgeschlossener
Bearbeitung Ihrer Anfrage). Zwingende gesetzliche Bestimmungen –
insbesondere Aufbewahrungsfristen – bleiben unberührt.</font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif"><font size="4" style="font-size: 13pt"><b>Registrierung
auf dieser Website</b></font></font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif">Sie können sich auf unserer
Website registrieren, um zusätzliche Funktionen auf der Seite zu
nutzen. Die dazu eingegebenen Daten verwenden wir nur zum Zwecke der
Nutzung des jeweiligen Angebotes oder Dienstes, für den Sie sich
registriert haben. Die bei der Registrierung abgefragten
Pflichtangaben müssen vollständig angegeben werden. Anderenfalls
werden wir die Registrierung ablehnen.</font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif">Für wichtige Änderungen etwa
beim Angebotsumfang oder bei technisch notwendigen Änderungen nutzen
wir die bei der Registrierung angegebene E-Mail-Adresse, um Sie auf
diesem Wege zu informieren.</font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif">Die Verarbeitung der bei der
Registrierung eingegebenen Daten erfolgt auf Grundlage Ihrer
Einwilligung (Art. 6 Abs. 1 lit. a DSGVO). Sie können eine von Ihnen
erteilte Einwilligung jederzeit widerrufen. Dazu reicht eine formlose
Mitteilung per E-Mail an uns. Die Rechtmäßigkeit der bereits
erfolgten Datenverarbeitung bleibt vom Widerruf unberührt.</font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif">Die bei der Registrierung
erfassten Daten werden von uns gespeichert, solange Sie auf unserer
Website registriert sind und werden anschließend gelöscht.
Gesetzliche Aufbewahrungsfristen bleiben unberührt.</font></p>
<p style="line-height: 100%; margin-top: 0.19in; margin-bottom: 0.19in">
<br/>
<br/>

</p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif"><font size="4" style="font-size: 13pt"><b>Verarbeiten
von Daten (Kunden- und Vertragsdaten)</b></font></font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif">Wir erheben, verarbeiten und
nutzen personenbezogene Daten nur, soweit sie für die Begründung,
inhaltliche Ausgestaltung oder Änderung des Rechtsverhältnisses
erforderlich sind (Bestandsdaten). Dies erfolgt auf Grundlage von
Art. 6 Abs. 1 lit. b DSGVO, der die Verarbeitung von Daten zur
Erfüllung eines Vertrags oder vorvertraglicher Maßnahmen gestattet.
Personenbezogene Daten über die Inanspruchnahme unserer
Internetseiten (Nutzungsdaten) erheben, verarbeiten und nutzen wir
nur, soweit dies erforderlich ist, um dem Nutzer die Inanspruchnahme
des Dienstes zu ermöglichen oder abzurechnen.</font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif">Die erhobenen Kundendaten werden
nach Abschluss des Auftrags oder Beendigung der Geschäftsbeziehung
gelöscht. Gesetzliche Aufbewahrungsfristen bleiben unberührt.</font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
&nbsp;&nbsp;</p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif"><font size="4" style="font-size: 13pt"><b>Datenübermittlung
bei Vertragsschluss für Dienstleistungen und digitale Inhalte</b></font></font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif">Wir übermitteln personenbezogene
Daten an Dritte nur dann, wenn dies im Rahmen der Vertragsabwicklung
notwendig ist, etwa an das mit der Zahlungsabwicklung beauftragte
Kreditinstitut.</font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif">Eine weitergehende Übermittlung
der Daten erfolgt nicht bzw. nur dann, wenn Sie der Übermittlung
ausdrücklich zugestimmt haben. Eine Weitergabe Ihrer Daten an Dritte
ohne ausdrückliche Einwilligung, etwa zu Zwecken der Werbung,
erfolgt nicht.</font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif">Grundlage für die
Datenverarbeitung ist Art. 6 Abs. 1 lit. b DSGVO, der die
Verarbeitung von Daten zur Erfüllung eines Vertrags oder
vorvertraglicher Maßnahmen gestattet.</font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
&nbsp;</p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
&nbsp;</p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif"><font size="4" style="font-size: 13pt"><b>5.
Analyse Tools und Werbung<!-- nutzen wir das? wenn nicht kann das weg.
 --></b></font></font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif"><font size="4" style="font-size: 13pt"><b>Google
Analytics</b></font></font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif">Diese Website nutzt Funktionen
des Webanalysedienstes Google Analytics. Anbieter ist die Google
Inc., 1600 Amphitheatre Parkway, Mountain View, CA 94043, USA.</font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif">Google Analytics verwendet so
genannte “Cookies”. Das sind Textdateien, die auf Ihrem Computer
gespeichert werden und die eine Analyse der Benutzung der Website
durch Sie ermöglichen. Die durch den Cookie erzeugten Informationen
über Ihre Benutzung dieser Website werden in der Regel an einen
Server von Google in den USA übertragen und dort gespeichert.</font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif">Die Speicherung von
Google-Analytics-Cookies erfolgt auf Grundlage von Art. 6 Abs. 1 lit.
f DSGVO. Der Websitebetreiber hat ein berechtigtes Interesse an der
Analyse des Nutzerverhaltens, um sowohl sein Webangebot als auch
seine Werbung zu optimieren.</font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
&nbsp;</p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif"><font size="4" style="font-size: 13pt"><b>IP-Anonymisierung</b></font></font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif">Wir haben auf dieser Website die
Funktion IP-Anonymisierung aktiviert. Dadurch wird Ihre IP-Adresse
von Google innerhalb von Mitgliedstaaten der Europäischen Union oder
in anderen Vertragsstaaten des Abkommens über den Europäischen
Wirtschaftsraum vor der Übermittlung in die USA gekürzt. Nur in
Ausnahmefällen wird die volle IP-Adresse an einen Server von Google
in den USA übertragen und dort gekürzt. Im Auftrag des Betreibers
dieser Website wird Google diese Informationen benutzen, um Ihre
Nutzung der Website auszuwerten, um Reports über die
Websiteaktivitäten zusammenzustellen und um weitere mit der
Websitenutzung und der Internetnutzung verbundene Dienstleistungen
gegenüber dem Websitebetreiber zu erbringen. Die im Rahmen von
Google Analytics von Ihrem Browser übermittelte IP-Adresse wird
nicht mit anderen Daten von Google zusammengeführt.</font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
&nbsp;</p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif"><font size="4" style="font-size: 13pt"><b>Browser
Plugin</b></font></font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif">Sie können die Speicherung der
Cookies durch eine entsprechende Einstellung Ihrer Browser-Software
verhindern; wir weisen Sie jedoch darauf hin, dass Sie in diesem Fall
gegebenenfalls nicht sämtliche Funktionen dieser Website
vollumfänglich werden nutzen können. Sie können darüber hinaus
die Erfassung der durch den Cookie erzeugten und auf Ihre Nutzung der
Website bezogenen Daten (inkl. Ihrer IP-Adresse) an Google sowie die
Verarbeitung dieser Daten durch Google verhindern, indem Sie das
unter dem folgenden Link verfügbare Browser-Plugin herunterladen und
installieren:&nbsp;</font><a href="https://tools.google.com/dlpage/gaoptout?hl=de" target="_blank"><font color="#0000ff"><font face="Times New Roman, serif"><u>https://tools.google.com/dlpage/gaoptout?hl=de</u></font></font></a><font face="Times New Roman, serif">.</font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
&nbsp;</p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif"><font size="4" style="font-size: 13pt"><b>Widerspruch
gegen Datenerfassung</b></font></font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif">Sie können die Erfassung Ihrer
Daten durch Google Analytics verhindern, indem Sie auf folgenden Link
klicken. Es wird ein Opt-Out-Cookie gesetzt, der die Erfassung Ihrer
Daten bei zukünftigen Besuchen dieser Website verhindert:&nbsp;Google
Analytics deaktivieren.</font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif">Mehr Informationen zum Umgang mit
Nutzerdaten bei Google Analytics finden Sie in der
Datenschutzerklärung von
Google:&nbsp;</font><a href="https://support.google.com/analytics/answer/6004245?hl=de" target="_blank"><font color="#0000ff"><font face="Times New Roman, serif"><u>https://support.google.com/analytics/answer/6004245?hl=de</u></font></font></a><font face="Times New Roman, serif">.</font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
&nbsp;</p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif"><font size="4" style="font-size: 13pt"><b>Auftragsdatenverarbeitung</b></font></font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif">Wir haben mit Google einen
Vertrag zur Auftragsdatenverarbeitung abgeschlossen und setzen die
strengen Vorgaben der deutschen Datenschutzbehörden bei der Nutzung
von Google Analytics vollständig um.</font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
&nbsp;</p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif"><font size="4" style="font-size: 13pt"><b>WordPress
Stats<!-- nutzen wir das? wenn nicht kann das weg. --></b></font></font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif">Diese Website nutzt das WordPress
Tool Stats, um Besucherzugriffe statistisch auszuwerten. Anbieter ist
die Automattic Inc., 60 29th Street #343, San Francisco, CA
94110-4929, USA.</font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif">WordPress Stats verwendet
Cookies, die auf Ihrem Computer gespeichert werden und die eine
Analyse der Benutzung der Website erlauben. Die durch die Cookies
generierten Informationen über die Benutzung unserer Website werden
auf Servern in den USA gespeichert. Ihre IP-Adresse wird nach der
Verarbeitung und vor der Speicherung anonymisiert.</font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
“<font face="Times New Roman, serif">WordPress-Stats”-Cookies
verbleiben auf Ihrem Endgerät, bis Sie sie löschen.</font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif">Die Speicherung von “WordPress
Stats”-Cookies erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f
DSGVO. Der Websitebetreiber hat ein berechtigtes Interesse an der
anonymisierten Analyse des Nutzerverhaltens, um sowohl sein
Webangebot als auch seine Werbung zu optimieren.</font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif">Sie können Ihren Browser so
einstellen, dass Sie über das Setzen von Cookies informiert werden
und Cookies nur im Einzelfall erlauben, die Annahme von Cookies für
bestimmte Fälle oder generell ausschließen sowie das automatische
Löschen der Cookies beim Schließen des Browser aktivieren. Bei der
Deaktivierung von Cookies kann die Funktionalität unserer Website
eingeschränkt sein.</font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif">Sie können der Erhebung und
Nutzung Ihrer Daten für die Zukunft widersprechen, indem Sie mit
einem Klick auf diesen Link einen Opt-Out-Cookie in Ihrem Browser
setzen:&nbsp;</font><a href="https://www.quantcast.com/opt-out/" target="_blank"><font color="#0000ff"><font face="Times New Roman, serif"><u>https://www.quantcast.com/opt-out/</u></font></font></a><font face="Times New Roman, serif">.</font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif">Wenn Sie die Cookies auf Ihrem
Rechner löschen, müssen Sie den Opt-Out-Cookie erneut setzen.</font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
&nbsp;</p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif">Diese Website verwendet Google
AdWords. AdWords ist ein Online-Werbeprogramm der Google Inc., 1600
Amphitheatre Parkway, Mountain View, CA 94043, United States
(“Google”).</font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif">Im Rahmen von Google AdWords
nutzen wir das so genannte Conversion-Tracking. Wenn Sie auf eine von
Google geschaltete Anzeige klicken wird ein Cookie für das
Conversion-Tracking gesetzt. Bei Cookies handelt es sich um kleine
Textdateien, die der Internet-Browser auf dem Computer des Nutzers
ablegt. Diese Cookies verlieren nach 30 Tagen ihre Gültigkeit und
dienen nicht der persönlichen Identifizierung der Nutzer. Besucht
der Nutzer bestimmte Seiten dieser Website und das Cookie ist noch
nicht abgelaufen, können Google und wir erkennen, dass der Nutzer
auf die Anzeige geklickt hat und zu dieser Seite weitergeleitet
wurde.</font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif">Jeder Google AdWords-Kunde erhält
ein anderes Cookie. Die Cookies können nicht über die Websites von
AdWords-Kunden nachverfolgt werden. Die mithilfe des
Conversion-Cookies eingeholten Informationen dienen dazu,
Conversion-Statistiken für AdWords-Kunden zu erstellen, die sich für
Conversion-Tracking entschieden haben. Die Kunden erfahren die
Gesamtanzahl der Nutzer, die auf ihre Anzeige geklickt haben und zu
einer mit einem Conversion-Tracking-Tag versehenen Seite
weitergeleitet wurden. Sie erhalten jedoch keine Informationen, mit
denen sich Nutzer persönlich identifizieren lassen. Wenn Sie nicht
am Tracking teilnehmen möchten, können Sie dieser Nutzung
widersprechen, indem Sie das Cookie des Google Conversion-Trackings
über ihren Internet-Browser unter Nutzereinstellungen leicht
deaktivieren. Sie werden sodann nicht in die Conversion-Tracking
Statistiken aufgenommen.</font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif">Die Speicherung von
“Conversion-Cookies” erfolgt auf Grundlage von Art. 6 Abs. 1 lit.
f DSGVO. Der Websitebetreiber hat ein berechtigtes Interesse an der
Analyse des Nutzerverhaltens, um sowohl sein Webangebot als auch
seine Werbung zu optimieren.</font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif">Mehr Informationen zu Google
AdWords und Google Conversion-Tracking finden Sie in den
Datenschutzbestimmungen von
Google:&nbsp;</font><a href="https://www.google.de/policies/privacy/" target="_blank"><font color="#0000ff"><font face="Times New Roman, serif"><u>https://www.google.de/policies/privacy/</u></font></font></a><font face="Times New Roman, serif">.</font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif">Sie können Ihren Browser so
einstellen, dass Sie über das Setzen von Cookies informiert werden
und Cookies nur im Einzelfall erlauben, die Annahme von Cookies für
bestimmte Fälle oder generell ausschließen sowie das automatische
Löschen der Cookies beim Schließen des Browser aktivieren. Bei der
Deaktivierung von Cookies kann die Funktionalität dieser Website
eingeschränkt sein.</font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
&nbsp;</p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
&nbsp;</p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif"><font size="4" style="font-size: 13pt"><b>7.
Plugins und<!-- nutzen wir davon was? 

Youtube plugin ggf. um videos einzubinden? -->
Tools</b></font></font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif"><font size="4" style="font-size: 13pt"><b>YouTube</b></font></font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif">Unsere Website nutzt Plugins der
von Google betriebenen Seite YouTube. Betreiber der Seiten ist die
YouTube, LLC, 901 Cherry Ave., San Bruno, CA 94066, USA.</font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif">Wenn Sie eine unserer mit einem
YouTube-Plugin ausgestatteten Seiten besuchen, wird eine Verbindung
zu den Servern von YouTube hergestellt. Dabei wird dem YouTube-Server
mitgeteilt, welche unserer Seiten Sie besucht haben.</font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif">Wenn Sie in Ihrem YouTube-Account
eingeloggt sind, ermöglichen Sie YouTube, Ihr Surfverhalten direkt
Ihrem persönlichen Profil zuzuordnen. Dies können Sie verhindern,
indem Sie sich aus Ihrem YouTube-Account ausloggen.</font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif">Die Nutzung von YouTube erfolgt
im Interesse einer ansprechenden Darstellung unserer Online-Angebote.
Dies stellt ein berechtigtes Interesse im Sinne von Art. 6 Abs. 1
lit. f DSGVO dar.</font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif">Weitere Informationen zum Umgang
mit Nutzerdaten finden Sie in der Datenschutzerklärung von YouTube
unter:&nbsp;</font><a href="https://www.google.de/intl/de/policies/privacy" target="_blank"><font color="#0000ff"><font face="Times New Roman, serif"><u>https://www.google.de/intl/de/policies/privacy</u></font></font></a><font face="Times New Roman, serif">.</font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
&nbsp;</p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif"><font size="4" style="font-size: 13pt"><b>Google
Web Fonts</b></font></font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif">Diese Seite nutzt zur
einheitlichen Darstellung von Schriftarten so genannte Web Fonts, die
von Google bereitgestellt werden. Beim Aufruf einer Seite lädt Ihr
Browser die benötigten Web Fonts in ihren Browsercache, um Texte und
Schriftarten korrekt anzuzeigen.</font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif">Zu diesem Zweck muss der von
Ihnen verwendete Browser Verbindung zu den Servern von Google
aufnehmen. Hierdurch erlangt Google Kenntnis darüber, dass über
Ihre IP-Adresse unsere Website aufgerufen wurde. Die Nutzung von
Google Web Fonts erfolgt im Interesse einer einheitlichen und
ansprechenden Darstellung unserer Online-Angebote. Dies stellt ein
berechtigtes Interesse im Sinne von Art. 6 Abs. 1 lit. f DSGVO dar.</font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif">Wenn Ihr Browser Web Fonts nicht
unterstützt, wird eine Standardschrift von Ihrem Computer genutzt.</font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif">Weitere Informationen zu Google
Web Fonts finden Sie
unter&nbsp;</font><a href="https://developers.google.com/fonts/faq" target="_blank"><font color="#0000ff"><font face="Times New Roman, serif"><u>https://developers.google.com/fonts/faq</u></font></font></a><font face="Times New Roman, serif">&nbsp;und
in der Datenschutzerklärung von
Google:&nbsp;</font><a href="https://www.google.com/policies/privacy/" target="_blank"><font color="#0000ff"><font face="Times New Roman, serif"><u>https://www.google.com/policies/privacy/</u></font></font></a><font face="Times New Roman, serif">.</font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
&nbsp;</p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif"><font size="4" style="font-size: 13pt"><b>Google
Maps</b></font></font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif">Diese Seite nutzt über eine API
den Kartendienst Google Maps. Anbieter ist die Google Inc., 1600
Amphitheatre Parkway, Mountain View, CA 94043, USA.</font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif">Zur Nutzung der Funktionen von
Google Maps ist es notwendig, Ihre IP Adresse zu speichern. Diese
Informationen werden in der Regel an einen Server von Google in den
USA übertragen und dort gespeichert. Der Anbieter dieser Seite hat
keinen Einfluss auf diese Datenübertragung.</font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif">Die Nutzung von Google Maps
erfolgt im Interesse einer ansprechenden Darstellung unserer
Online-Angebote und an einer leichten Auffindbarkeit der von uns auf
der Website angegebenen Orte. Dies stellt ein berechtigtes Interesse
im Sinne von Art. 6 Abs. 1 lit. f DSGVO dar.</font></p>
<p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
<font face="Times New Roman, serif">Mehr Informationen zum Umgang mit
Nutzerdaten finden Sie in der Datenschutzerklärung von
Google:&nbsp;</font><a href="https://www.google.de/intl/de/policies/privacy/" target="_blank"><font color="#0000ff"><font face="Times New Roman, serif"><u>https://www.google.de/intl/de/policies/privacy/</u></font></font></a><font face="Times New Roman, serif">.</font></p>
<p style="margin-bottom: 0in; line-height: 100%"><br/>

</p>




`




function App() {
  const {clientWidth, clientHeight} =  document.documentElement;
  const [mobile, setMobile] = React.useState(clientWidth < clientHeight);
  const [tabIndex, setTabIndex] = useState(0); // Control tab selection
  const [termineContent, setTermineContent] = useState("Laden...");

  useEffect(() => {
    fetch("/api/getTermine")
      .then((res) => res.json())
      .then((data) => setTermineContent(data.content))
      .catch(() => setTermineContent("Fehler beim Laden der Termine."));
  }, []);
  
  window.addEventListener("resize", ()=>{
    setMobile(document.documentElement.clientWidth < document.documentElement.clientHeight);
  });

  return (
    <div className="App">
      <header className="App-header">
        <img className="logo" src="/images/logo.png" alt="logo" />
      </header>
      <Tabs selectedIndex={tabIndex} onSelect={(index) => setTabIndex(index)}>
        <TabList>
          <Tab style={{display: mobile?'block':'inline-block'}}>
            Der Verein
          </Tab>
          <Tab style={{display: mobile?'block':'inline-block'}}>
            Fotos
          </Tab>
          <Tab style={{display: mobile?'block':'inline-block'}}>
            Termine
          </Tab>
          <Tab style={{display: mobile?'block':'inline-block'}}>
            Anmeldung
          </Tab>
          <Tab style={{display: mobile?'block':'inline-block'}}>
            Spenden
          </Tab>
        </TabList>

        <TabPanel>
        <div className='content'>
          <h2>Kneipenchor Linden e.V.</h2>
          {/*
          <p>
            Willkommen auf der offiziellen Website des 'Kneipenchor'. Wir sind eine Gruppe von Enthusiasten*innen, die sich leidenschaftlich dem edlen Sport des Biersingens verschrieben haben.
          </p>
          */}
          <p>
Alles fing mit einer Schnapsidee an. Oder besser: mit einem „leckeren Bierchen“ im Lindwurm. Im Herbst 2023 fanden sich ein paar musikverliebte Menschen zusammen, die keine Lust auf steife Chorproben und klassische Stücke hatten – sondern auf Pop, Deutschpop, gute Laune und ein bisschen Chaos. Der Kneipenchor Linden war geboren.
<br></br>
<br></br>
Seitdem ist viel passiert: Der Chor ist jetzt ein eingetragener Verein – nach ein paar Startschwierigkeiten. Denn bei der Gründung gab’s einen kleinen Haken: „Lecker Bierchen trinken“ zählt laut Amtsgericht nicht als gemeinnütziger Zweck. (Können wir nicht ganz nachvollziehen, ehrlich gesagt.)
<br></br>
<br></br>
Trotzdem: Wir stehen, wir singen, wir feiern das Leben – mit einem Repertoire, das irgendwo zwischen Gänsehaut, Schmunzeln und Mitsing-Feeling liegt.
<br></br>
<br></br>
Ob auf dem SNNTG Festival 2024 oder bei unserem legendären Kneipenauftritt im Lindwurm – wir bringen Bühnen und Bierbänke zum Beben. Und wenn’s mal ein Klavier braucht? Dann wird das eben aus dem dritten Stock getragen und auf Rollbrettern über die Limmerstraße bugsiert.
<br></br>
<br></br>
Unter der Leitung von Lasse Altmark aka „Amigo Altmark“ wachsen wir stetig – und freuen uns über alle, die mitsingen wollen. Bei uns geht’s nicht um Perfektion. Es geht um Musik, Menschen und Momente, die bleiben.
          </p>
        </div>
        </TabPanel>
        <TabPanel>
          <h2></h2>
        </TabPanel>
        <TabPanel>
          <div style={{ padding: "20px", whiteSpace: "pre-wrap" }}>
            {termineContent}
          </div>
        </TabPanel>
        <TabPanel>
            <Register/>
        </TabPanel>
        <TabPanel>
          <div style={{ padding:"40px",margin: "0px",  textAlign: "center" }}>
            <h3>
              Wir freuen uns riesig über Spenden, um unsere Druckkosten, Chorfahrten und unseren wunderbaren Chorleiter zu finanzieren.
              <br></br>
              <br></br>
              <br></br>
              Spendenkonto:
              <br></br>
              <br></br>
              Kneipenchor Linden e.V.
              <br></br>
              IBAN: DE24 8306 5408 0005 4899 11
              <br></br>
              BIC: GENO DEF1 SLR
              <br></br>
              <br></br>
              Gerne den Verwendungszweck "Spende" angeben.
              <br></br>
              <br></br>
              <br></br>

              Vielen Dank ♥♥♥
            </h3>
          </div>
        </TabPanel>

        <TabPanel>
          <div className="content">

          <div dangerouslySetInnerHTML={{ __html: impressum }} />;
          <div dangerouslySetInnerHTML={{ __html: datenschutz }} />;


          </div>
        </TabPanel>


      </Tabs>
      <footer className='footer'>
        <Grid>
            {/*
          <img className="logo" src="/images/herri.png" alt="sponsor" />
            */}
          <img className="logo" src="/images/lw.png" alt="sponsor" />
          <img className="logo" src="/images/hanne.png" alt="sponsor" />
        </Grid>
        <div style={{ padding:"40px",margin: "0px",  textAlign: "center" }}>
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              setTabIndex(5); // 👈 Select hidden "Impressum" tab
            }}
            style={{ textDecoration: "underline", cursor: "pointer", color: "#aaa" }}
          >
            Impressum & Datenschutz
          </a>
        </div>
      </footer>

    </div>
  );
}

type GridProps={
  children:any
}
function Grid({children}:GridProps){
  return <div className='GridParent'>
    {children}
  </div>

}

export default App;
